import {React, Container, Row, Col} from "./eevi_react_exports";

export function EeviContent(props: {children: React.ReactNode}) {
    return <>
        <div className="eevi_white_band"/>
        <Container><Row><Col>{props.children}</Col></Row></Container>
    </>;
}
